import { Avatar, Box, Chip, Flex, Link, Typography } from "../../ppui";
import { formatIndianCurrency, formatToCustomDate } from "../../utils/common";

export const headers = (currentPage, rowsPerPage, branchList) => [
  {
    key: "sl_no",
    label: "Sl. No.",
    isVisible: true,
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "employee_id",
    label: "Employee Id",
    isShortable: false,
    isVisible: "",
    text: "capitalize",
    getValue: (row) => row?.employee_id || "--",
  },
  {
    key: "full_name",
    label: "Name",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (row) => (
      <Link to={`/employee/${row?.employee_id}`} color="secondary" underline="none">
        <Flex alignItem="center">
          <Avatar
            className={"avatarHover"}
            size="xs"
            initials={`${row?.first_name?.trim().substring(0, 1).toUpperCase() || ""}${row?.last_name?.trim().substring(0, 1).toUpperCase() || ""}`}
            color="secondary"
            sx={{ marginInlineEnd: "0.625rem" }}
          />
          <Box color={"secondary"}>
            {row?.first_name || "--"} {row?.last_name || "--"}
            <br />
            <Typography color={"default"} colorVariant={"light"} variant={"body3"} mb={"0"}>
              #{row?.employee_code || "--"}
            </Typography>
          </Box>
        </Flex>
      </Link>
    ),
  },
  {
    key: "phone",
    label: "Phone No",
    isShortable: false,
    isVisible: true,
    text: "capitalize",
    getValue: (row) => row?.phone || "--",
  },
  {
    key: "email",
    label: "Email",
    isShortable: false,
    isVisible: "",
    text: "capitalize",
    getValue: (row) => row?.email || "--",
  },
  {
    key: "gender",
    label: "Gender",
    isShortable: true,
    isVisible: false,
    getValue: (row) => (
      <Chip
        color="primary"
        label={row?.gender ? row.gender.trim().substring(0, 1).toUpperCase() : "--"}
        variant="filled"
        noHover
      />
    ),
  },
  {
    key: "blood_group",
    label: "Blood Group",
    isShortable: false,
    isVisible: "",
    text: "capitalize",
    getValue: (row) => row?.blood_group || "--",
  },
  {
    key: "guardian_name",
    label: "Guardian Name",
    isShortable: false,
    isVisible: "",
    text: "capitalize",
    getValue: (row) => row?.guardian_name || "--",
  },
  {
    key: "date_of_birth",
    label: "Date of Birth",
    isShortable: true,
    isVisible: false,
    getValue: (row) => (row?.date_of_birth ? formatToCustomDate(new Date(row.date_of_birth)) : "--"),
  },
  {
    key: "join_date",
    label: "Joining Date",
    isShortable: true,
    isVisible: false,
    getValue: (row) => (row?.join_date ? formatToCustomDate(new Date(row.join_date)) : "--"),
  },
  {
    key: "exit_date",
    label: "Exit Date",
    isShortable: false,
    isVisible: "",
    getValue: (row) => (row?.exit_date ? formatToCustomDate(new Date(row.exit_date)) : "--"),
  },
  {
    key: "designation",
    label: "Designation",
    isShortable: true,
    isVisible: false,
    text: "capitalize",
    getValue: (row) => row?.designation?.designation_name || "--",
  },
  {
    key: "department",
    label: "Department",
    isShortable: true,
    isVisible: false,
    text: "capitalize",
    getValue: (row) => row?.department?.dept_name || "--",
  },
  {
    key: "branch",
    label: "Branch",
    isShortable: true,
    isVisible: "",
    text: "capitalize",
    getValue: (row) => (row?.branch_id?
      branchList?.find((it) => it?.id === row?.branch_id) ?.name || "--"
      : "--" || "--")
  },

  {
    key: "present_address",
    label: "Present Address",
    isShortable: false,
    isVisible: "",
    text: "capitalize",
    getValue: (row) => row?.present_address || "--",
  },
  {
    key: "permanent_address",
    label: "Permanent Address",
    isShortable: false,
    isVisible: "",
    text: "capitalize",
    getValue: (row) => row?.permanent_address || "--",
  },
 
  {
    key: "emp_type",
    label: "Employee Type",
    isShortable: false,
    isVisible: false,
    getValue: (row) => (
      <Chip
        color={
          row?.settlement_date
            ? "danger"
            : row?.employment_type === "probationary"
              ? "warning"
              : row?.employment_type === "full_time"
                ? "success"
                : row?.employment_type === "contractual"
                  ? "info" : "dark"
        }
        label={row?.settlement_date ? "resign"
          : row?.employment_type === "full_time"
            ? "permanent"
            : row?.employment_type === "probationary"
              ? "Probationary"
              : row?.employment_type === "contractual"
                ? "contractual" : "--"}
        variant="text"
        noHover
        dot
        sx={{ textTransform: "capitalize" }}
      />
    ),
  },
  // {
  //   key: "status",
  //   label: "Status",
  //   isShortable: false,
  //   isVisible: false,
  //   getValue: (row) => (
  //     <Chip
  //       color={
  //         row?.status === "active"
  //           ? "success"
  //           : row?.status === "draft"
  //           ? "warning"
  //           : row?.status === "resign"
  //           ? "danger"
  //           : "default"
  //       }
  //       label={row?.status || "--"}
  //       variant="filled"
  //       noHover
  //       dot
  //       sx={{ textTransform: "capitalize" }}
  //     />
  //   ),
  // },
  {
    key: "benefits_salary_type",
    label: "Salary Type",
    isShortable: false,
    isVisible: false,
    getValue: (row) => row?.benefits?.salary_type ? row?.benefits?.salary_type.toUpperCase() : "--",
  },
  {
    key: "salary_type",
    label: "Profile Salary Type",
    isShortable: false,
    isVisible: "",
    getValue: (row) => row?.salary_type || "--",
  },
  {
    key: "gross_salary",
    label: "Gross Salary",
    isShortable: false,
    align: "right",
    isVisible: false,
    getValue: (row) =>  `₹ ${row?.salary_info?.gross_salary? formatIndianCurrency(row?.salary_info?.gross_salary.toFixed(2)) : 0.00}`,
  },
  {
    key: "ot_rate",
    label: "OT Rate",
    align: "right",
    isShortable: true,
    isVisible: "",
    // getValue: (row) => "₹" + formatIndianCurrency(row?.salary_info?.gross_salary.toFixed(2)) || "--",
    getValue: (row) => `₹ ${row?.benefits?.ot_rate? row?.benefits?.ot_rate.toFixed(2) : 0.00}`,
  },
  {
    key: "uan_no",
    label: "UAN",
    isShortable: false,
    isVisible: "",
    getValue: (row) => row?.uan_no || "--",
  },
  {
    key: "bank_name",
    label: "Bank Name",
    isShortable: false,
    isVisible: "",
    text: "capitalize",
    getValue: (row) => row?.bank_name || "--",
  },
  {
    key: "account_number",
    label: "Account Number",
    isShortable: false,
    isVisible: "",
    getValue: (row) => row?.account_number || "--",
  },
  {
    key: "esic_insurance_number",
    label: "ESI No",
    isShortable: false,
    isVisible: "",
    getValue: (row) => row?.esic_insurance_number || "--",
  },
  
];


